import { useCallback, useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { FunnelTopBar } from "@/components/funnel/FunnelTopBar";
import { FunnelHero } from "@/components/funnel/FunnelHero";
import { Marquee } from "@/components/Marquee";
import { FunnelProblem } from "@/components/funnel/FunnelProblem";
import { FunnelSolution } from "@/components/funnel/FunnelSolution";
import { FunnelServices } from "@/components/funnel/FunnelServices";
import { FunnelHow } from "@/components/funnel/FunnelHow";
import { Gallery } from "@/components/Gallery";
import { FunnelPricing } from "@/components/funnel/FunnelPricing";
import { FunnelSchedule } from "@/components/funnel/FunnelSchedule";
import { FunnelCreative } from "@/components/funnel/FunnelCreative";
import { FunnelClients } from "@/components/funnel/FunnelClients";
import { FunnelTrust } from "@/components/funnel/FunnelTrust";
import { FunnelQuote } from "@/components/funnel/FunnelQuote";
import { FunnelBooking } from "@/components/funnel/FunnelBooking";
import { AdminApp } from "@/components/admin/AdminApp";

function App() {
    const isAdmin = window.location.pathname.startsWith("/admin");
    const [prefill, setPrefill] = useState(null);
    const applyPrefill = useCallback((packageId) => setPrefill({ packageId, ts: Date.now() }), []);

    useEffect(() => {
        if (isAdmin) return;
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, [isAdmin]);

    if (isAdmin) {
        return <AdminApp />;
    }

    return (
        <div className="App bg-noir min-h-screen">
            <FunnelTopBar />
            <main>
                <FunnelHero />
                <Marquee />
                <FunnelProblem />
                <FunnelSolution />
                <FunnelServices />
                <FunnelHow />
                <Gallery />
                <FunnelPricing onSelectPackage={applyPrefill} />
                <FunnelSchedule />
                <FunnelCreative />
                <FunnelClients />
                <FunnelTrust />
                <FunnelQuote prefill={prefill} />
                <FunnelBooking />
            </main>
            <Toaster position="top-center" richColors />
        </div>
    );
}

export default App;
